import {
  GET_PURCHASEHISTORY,
  GET_PURCHASEHISTORY_SUCCESS,
  GET_PURCHASEHISTORY_FAIL,
  DELETE_PURCHASEHISTORY,
  DELETE_PURCHASEHISTORY_SUCCESS,
  DELETE_PURCHASEHISTORY_FAIL,
  UPDATE_PURCHASEHISTORY,
  UPDATE_PURCHASEHISTORY_SUCCESS,
  UPDATE_PURCHASEHISTORY_FAIL,
  ADD_NEW_PURCHASEHISTORY,
  ADD_PURCHASEHISTORY_SUCCESS,
  ADD_PURCHASEHISTORY_FAIL,
  PURCHASEHISTORY_LOADING,
  PURCHASEHISTORY_RESET,
} from "./actionType";

export const resetPurchaseHistoryState = (actionType) => ({
  type: PURCHASEHISTORY_RESET,
  payload: { actionType },
});

export const getPurchaseHistorySuccess = (actionType, data) => ({
  type: GET_PURCHASEHISTORY_SUCCESS,
  payload: { actionType, data },
});

export const getPurchaseHistoryFail = (actionType, error) => ({
  type: GET_PURCHASEHISTORY_FAIL,
  payload: { actionType, error },
});

export const getPurchaseHistory = data => ({
  type: GET_PURCHASEHISTORY,
  payload: data,
});

export const getPurchaseHistoryLoading = () => ({
  type: PURCHASEHISTORY_LOADING
});

export const deletePurchaseHistory = data => ({
  type: DELETE_PURCHASEHISTORY,
  payload: data,
});

export const deletePurchaseHistorySuccess = data => ({
  type: DELETE_PURCHASEHISTORY_SUCCESS,
  payload: data,
});

export const deletePurchaseHistoryFail = error => ({
  type: DELETE_PURCHASEHISTORY_FAIL,
  payload: error,
});

export const updatePurchaseHistory = data => ({
  type: UPDATE_PURCHASEHISTORY,
  payload: data,
});

export const updatePurchaseHistoryFail = error => ({
  type: UPDATE_PURCHASEHISTORY_FAIL,
  payload: error,
});

export const updatePurchaseHistorySuccess = data => ({
  type: UPDATE_PURCHASEHISTORY_SUCCESS,
  payload: data,
});

export const addNewPurchaseHistory = data => ({
  type: ADD_NEW_PURCHASEHISTORY,
  payload: data,
});

export const addPurchaseHistorySuccess = data => ({
  type: ADD_PURCHASEHISTORY_SUCCESS,
  payload: data,
});

export const addPurchaseHistoryFail = error => ({
  type: ADD_PURCHASEHISTORY_FAIL,
  payload: error,
});